var url
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
    url = 'http://127.0.0.1:8000/api/v1';
// url = 'https://api.qc-lab.ir/api/v1';
else
    url = 'https://api.qc-lab.ir/api/v1';
export const BASE_URL = url;

export const ITEMS_PER_PAGE = 10;